module.exports = __webpack_public_path__ + "static/cosycolour1-00d1e0ad7d3e9907376b2f517a208cd2.png";